import * as React from 'react';
import { TitleCustom, ParagraphCustom, ButtonsCustom } from '../custom';
import { v4 as uuidv4 } from 'uuid';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Trans, useTranslation } from 'react-i18next';
import { Form, Radio, Input, InputNumber, Skeleton, Switch, Button, Space, Alert } from 'antd';
import { useEffect, useState, useContext } from 'react';
import { RestApiClientContext } from 'src/hooks/context/pageContext';
import './referrals.sass';
export interface Referrals {
    id: string; // UUID
    referrer: string; // UUID del agente que refiere
    referrerBy?: string; // UUID del agente que fue referido
    bookingId?: string; // UUID de la reserva, si aplica
    amount?: number; // Monto asociado al referido (si bookingId existe)
    createdAt: Date;
    referrerAgent?: any;
    referrerByAgent?: any;
    booking?: any;
}

export interface ReferralsAmount {
    idCurrency: string; // Código de moneda, ej: 'EUR'
    amount: any;
    amountType: 'percent' | 'fixed'; // Solo esos dos valores permitidos
    type: 'REFERRER' | 'REFERRED';
    id: string;
    from?: number;
    to?: number;
}
export default function ReferralsForm() {
    const { t } = useTranslation(['referrals', 'rewards']);
    const restApiClient = useContext(RestApiClientContext);

    const [form] = Form.useForm();
    const [formReferrer] = Form.useForm();

    const [loading, setLoading] = useState(true);
    const [loadingUpdate, setLoadingUpdate] = useState(false);
    const [loadingTransformCurrencies, setLoadingTransformCurrencies] = useState(false);
    const [currencyList, setCurrencyList] = useState<string[]>([]);
    const [radioValueMapReferrer, setRadioValueMapReferrer] = useState({});
    const [radioValuePercentajeReferrer, setRadioValuePercentajeReferrer] = useState({});
    const [radioValueMapReferred, setRadioValueMapReferred] = useState({});
    const [radioValuePercentajeReferred, setRadioValuePercentajeReferred] = useState({});
    const [referralsUniqueOrPerNight, setReferralsUniqueOrPerNight] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const currencies = await restApiClient.getListCurrency();
            const data: ReferralsAmount[] = await restApiClient.getReferrals();
            const referralType = await restApiClient.GetReferralsUniqueOrPerNight();
            setReferralsUniqueOrPerNight(referralType);
            setCurrencyList(currencies);

            const referrer = [];
            const referred = [];
            data.forEach((item) => {
                if (item.type === 'REFERRER') {
                    referrer.push(item);
                } else {
                    referred.push(item);
                }
            });
            const referrerDataReduced = referrer.reduce((acc, refer) => {
                const clave = refer.referenceReferralAmount;
                if (!acc[clave]) {
                    acc[clave] = [];
                }
                acc[clave].push(refer);
                return acc;
            }, {});

            const referredDataReduced = referred.reduce((acc, refer) => {
                const clave = refer.referenceReferralAmount;
                if (!acc[clave]) {
                    acc[clave] = [];
                }
                acc[clave].push(refer);
                return acc;
            }, {});

            // setReferralAmounts(grouped);
            const initialValuesReferred = { groups: [] };
            const radioStateReferred = {};
            const percentStateReferred = {};
            Object.entries(referredDataReduced).forEach(([refId, items]) => {
                const group = {
                    referenceReferralAmount: refId,
                    percent: null,
                    from: null,
                    to: null,
                    id: null,
                };
                const isPercent = items[0].amountType === 'percent';

                if (isPercent) {
                    group.percent = items[0].amount;
                    percentStateReferred[refId] = items[0].amount;
                    radioStateReferred[refId] = 1;
                } else {
                    (items as any[]).forEach((item) => {
                        group[item.idCurrency] = item.amount;
                    });
                    radioStateReferred[refId] = 2;
                }
                group.from = items[0].from ?? null;
                group.to = items[0].to ?? null;
                group.id = items ?? null;
                initialValuesReferred.groups.push(group);
            });
            if (initialValuesReferred.groups.length === 0) {
                initialValuesReferred.groups.push({
                    referenceReferralAmount: uuidv4(),
                    percent: null,
                    from: null,
                    to: null,
                    id: null,
                });
            }
            form.setFieldsValue(initialValuesReferred);
            setRadioValueMapReferrer(radioStateReferred);
            setRadioValuePercentajeReferred(percentStateReferred);

            const initialValuesGroups = { groups: [] };
            const radioState = {};
            const percentState = {};
            Object.entries(referrerDataReduced).forEach(([refId, items]) => {
                const group = {
                    referenceReferralAmount: refId,
                    percent: null,
                    from: null,
                    to: null,
                    id: null,
                };
                const isPercent = items[0].amountType === 'percent';

                if (isPercent) {
                    group.percent = items[0].amount;
                    percentState[refId] = items[0].amount;
                    radioState[refId] = 1;
                } else {
                    (items as any[]).forEach((item) => {
                        group[item.idCurrency] = item.amount;
                    });
                    radioState[refId] = 2;
                }
                group.from = items[0].from ?? null;
                group.to = items[0].to ?? null;
                group.id = items ?? null;
                initialValuesGroups.groups.push(group);
            });
            if (initialValuesGroups.groups.length === 0) {
                initialValuesGroups.groups.push({
                    referenceReferralAmount: uuidv4(),
                    percent: null,
                    from: null,
                    to: null,
                    id: null,
                });
            }
            formReferrer.setFieldsValue(initialValuesGroups);
            setRadioValueMapReferrer(radioState);
            setRadioValuePercentajeReferrer(percentState);
            setLoading(false);
        };

        fetchData();
    }, []);

    const handleConvert = async (groupName, currencies, type: 'REFERRED' | 'REFERRER') => {
        setLoadingTransformCurrencies(true);

        try {
            const groupValues =
                type === 'REFERRED'
                    ? form.getFieldValue(['groups', groupName])
                    : formReferrer.getFieldValue(['groups', groupName]);
            const baseCurrency = currencies[0];
            const baseValue = groupValues?.[baseCurrency];

            if (!baseValue || isNaN(baseValue)) {
                return; // Podrías lanzar un mensaje de error aquí si quieres
            }

            const converted = await Promise.all(
                currencies.slice(1).map(async (curr) => {
                    const result = await restApiClient.getCurrencyConversion({
                        currencyFrom: baseCurrency,
                        amount: baseValue,
                        currencyTo: curr,
                    });
                    return { currency: curr, value: result };
                }),
            );

            // Construir el nuevo objeto con los valores convertidos
            const newGroupValues = converted.reduce((acc, { currency, value }) => {
                acc[currency] = value;
                return acc;
            }, {});

            // Aplicar los nuevos valores en el grupo correcto
            type === 'REFERRED'
                ? form.setFields([
                      {
                          name: ['groups', groupName],
                          value: {
                              ...groupValues,
                              ...newGroupValues,
                          },
                      },
                  ])
                : formReferrer.setFields([
                      {
                          name: ['groups', groupName],
                          value: {
                              ...groupValues,
                              ...newGroupValues,
                          },
                      },
                  ]);
        } finally {
            setLoadingTransformCurrencies(false);
        }
    };
    const handleSubmit = async (type: 'REFERRER' | 'REFERRED') => {
        const allReferralAmounts = [];
        const validation =
            (await type) === 'REFERRER' ? formReferrer.validateFields() : form.validateFields();
        validation.then(() => {
            const values =
                type === 'REFERRER' ? formReferrer.getFieldsValue() : form.getFieldsValue();
            values.groups.forEach((group) => {
                const { referenceReferralAmount, percent, from, to, id, ...rest } = group;

                const amountType =
                    type === 'REFERRER'
                        ? radioValueMapReferrer[referenceReferralAmount] === 1
                            ? 'percent'
                            : 'fixed'
                        : radioValueMapReferred[referenceReferralAmount] === 1
                        ? 'percent'
                        : 'fixed';

                if (amountType === 'percent') {
                    // Solo un registro con amount en porcentaje
                    allReferralAmounts.push({
                        referenceReferralAmount: referenceReferralAmount,
                        idCurrency: '%',
                        amount: percent,
                        amountType: 'percent',
                        type: type,
                        from: from ?? 1,
                        to: to ?? null,
                        id: id?.[0].id ?? null,
                    });
                } else {
                    // Múltiples registros, uno por moneda
                    Object.entries(rest).forEach(([currency, amount]) => {
                        if (amount != null) {
                            allReferralAmounts.push({
                                referenceReferralAmount: referenceReferralAmount,
                                idCurrency: currency,
                                amount: amount,
                                amountType: 'fixed',
                                type: type,
                                from: from ?? 1,
                                to: to ?? null,
                                id: id?.find((item) => item.idCurrency === currency)?.id ?? null,
                            });
                        }
                    });
                }
            });
            restApiClient.patchReferral(allReferralAmounts);
        });
    };

    const renderSectionReferrer = () => {
        return (
            <>
                <div className="container-referral mb-4 ant-list-item p-0 not-line-down">
                    <div
                        style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
                    >
                        <TitleCustom
                            level={1}
                            class="title-section"
                            text={t('amount-agent-aport-refer-code')}
                        />{' '}
                        <ButtonsCustom
                            content={t('save')}
                            type="primary"
                            disabled={loadingUpdate}
                            loading={loadingUpdate}
                            className="btn-primary"
                            onClick={() => handleSubmit('REFERRER')}
                        />
                    </div>
                    <ParagraphCustom text={t('amount-agent-aport-refer-code-explication')} />
                    <Form style={{ width: '100%' }} form={formReferrer} layout="vertical">
                        <Form.List name="groups">
                            {(fields, { add, remove }) => (
                                <div style={{ width: '100%' }}>
                                    {fields.map(({ key, name }, idx) => {
                                        const refId =
                                            formReferrer.getFieldValue([
                                                'groups',
                                                name,
                                                'referenceReferralAmount',
                                            ]) || `new_${key}`;

                                        const radioValue = radioValueMapReferrer[refId] ?? 2;

                                        return (
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    width: '100%',
                                                    justifyContent: 'space-between',
                                                    display: 'flex',
                                                    gap: 10,
                                                    alignItems: 'start',
                                                    marginBottom: 10,
                                                    padding: '10px 20px',
                                                    borderRadius: '10px',
                                                    boxShadow: '5px 5px 10px #f3f3f3',
                                                    border: '1px solid #f2f2f2',
                                                }}
                                                key={key}
                                            >
                                                <Form.Item
                                                    name={[name, 'referenceReferralAmount']}
                                                    hidden
                                                >
                                                    <Input />
                                                </Form.Item>

                                                <div style={{ width: '100%' }}>
                                                    <Radio.Group
                                                        onChange={(e) =>
                                                            setRadioValueMapReferrer((prev) => ({
                                                                ...prev,
                                                                [refId]: e.target.value,
                                                            }))
                                                        }
                                                        value={radioValue}
                                                    >
                                                        <Space>
                                                            <Radio value={1}>{t('percent')}</Radio>
                                                            <Radio value={2}>{t('fixed')}</Radio>
                                                        </Space>
                                                    </Radio.Group>
                                                    <div
                                                        style={{
                                                            padding: 0,
                                                            margin: 0,
                                                            paddingTop: 5,
                                                        }}
                                                        className="col-12 row"
                                                    >
                                                        {radioValue === 1 && (
                                                            <Form.Item
                                                                className="p-0 m-0 col-9"
                                                                style={{ height: 'fit-content' }}
                                                                name={[name, 'percent']}
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message:
                                                                            'Introduce un valor',
                                                                    },
                                                                ]}
                                                            >
                                                                <Input
                                                                    suffix="%"
                                                                    max={100}
                                                                    onChange={(e) =>
                                                                        setRadioValuePercentajeReferrer(
                                                                            (prev) => ({
                                                                                ...prev,
                                                                                [refId]:
                                                                                    e.target.value,
                                                                            }),
                                                                        )
                                                                    }
                                                                    value={
                                                                        radioValuePercentajeReferrer[
                                                                            refId
                                                                        ]
                                                                    }
                                                                />
                                                            </Form.Item>
                                                        )}

                                                        {radioValue === 2 && (
                                                            <>
                                                                <div
                                                                    className="col-3 row"
                                                                    style={{
                                                                        gap: 12,
                                                                        flexWrap: 'wrap',
                                                                        padding: 0,
                                                                        margin: 0,
                                                                    }}
                                                                >
                                                                    <Form.Item
                                                                        className="p-0 m-0"
                                                                        style={{
                                                                            height: 'fit-content',
                                                                        }}
                                                                        key={`${refId}_${currencyList[0]}`}
                                                                        name={[
                                                                            name,
                                                                            currencyList[0],
                                                                        ]}
                                                                        help={false}
                                                                        rules={[
                                                                            {
                                                                                required:
                                                                                    radioValue == 2,
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <InputNumber
                                                                            style={{
                                                                                maxWidth: '140px',
                                                                            }}
                                                                            addonBefore={
                                                                                currencyList[0]
                                                                            }
                                                                            decimalSeparator=","
                                                                        />
                                                                    </Form.Item>
                                                                    <Button
                                                                        loading={
                                                                            loadingTransformCurrencies
                                                                        }
                                                                        disabled={
                                                                            loadingTransformCurrencies
                                                                        }
                                                                        type="primary"
                                                                        onClick={() =>
                                                                            handleConvert(
                                                                                name,
                                                                                currencyList,
                                                                                'REFERRER',
                                                                            )
                                                                        }
                                                                    >
                                                                        {t('convert')}
                                                                    </Button>
                                                                </div>
                                                                <div
                                                                    className="col-6"
                                                                    style={{
                                                                        display: 'flex',
                                                                        gap: 12,
                                                                        flexWrap: 'wrap',
                                                                        padding: 0,
                                                                    }}
                                                                >
                                                                    {currencyList?.map(
                                                                        (cur, index) => (
                                                                            <>
                                                                                {index > 0 && (
                                                                                    <Form.Item
                                                                                        className="p-0 m-0"
                                                                                        key={`${refId}_${cur}`}
                                                                                        name={[
                                                                                            name,
                                                                                            cur,
                                                                                        ]}
                                                                                        help={false}
                                                                                        style={{
                                                                                            height: 'fit-content',
                                                                                        }}
                                                                                        rules={[
                                                                                            {
                                                                                                required:
                                                                                                    radioValue ==
                                                                                                    2,
                                                                                            },
                                                                                        ]}
                                                                                    >
                                                                                        <InputNumber
                                                                                            style={{
                                                                                                maxWidth:
                                                                                                    '140px',
                                                                                            }}
                                                                                            addonBefore={
                                                                                                cur
                                                                                            }
                                                                                            decimalSeparator=","
                                                                                        />
                                                                                    </Form.Item>
                                                                                )}
                                                                            </>
                                                                        ),
                                                                    )}
                                                                </div>
                                                            </>
                                                        )}
                                                        <div
                                                            className="col-2 row"
                                                            style={{
                                                                margin: 0,
                                                                display: 'flex',
                                                                gap: 5,
                                                                alignItems: 'end',
                                                            }}
                                                        >
                                                            <Form.Item
                                                                className="p-0 m-0"
                                                                style={{
                                                                    height: 'fit-content',
                                                                    flex: 1,
                                                                }}
                                                                name={[name, 'from']}
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: t(
                                                                            'Introduce el valor inicial',
                                                                        ),
                                                                    },
                                                                    {
                                                                        validator: async (
                                                                            _,
                                                                            value,
                                                                        ) => {
                                                                            if (idx === 0)
                                                                                return Promise.resolve(); // no hay anterior

                                                                            const prevTo =
                                                                                formReferrer.getFieldValue(
                                                                                    [
                                                                                        'groups',
                                                                                        idx - 1,
                                                                                        'to',
                                                                                    ],
                                                                                );
                                                                            if (prevTo == null)
                                                                                return Promise.resolve(); // no hay to anterior definido aún

                                                                            if (value <= prevTo) {
                                                                                return Promise.reject(
                                                                                    new Error(
                                                                                        t(
                                                                                            "El valor 'Desde' debe ser mayor que el 'Hasta' del grupo anterior",
                                                                                        ),
                                                                                    ),
                                                                                );
                                                                            }

                                                                            return Promise.resolve();
                                                                        },
                                                                    },
                                                                ]}
                                                            >
                                                                <InputNumber
                                                                    addonBefore={t('from')}
                                                                    style={{ maxWidth: '140px' }}
                                                                    min={1}
                                                                />
                                                            </Form.Item>

                                                            <Form.Item
                                                                className="p-0 m-0"
                                                                name={[name, 'to']}
                                                                style={{
                                                                    height: 'fit-content',
                                                                    flex: 1,
                                                                }}
                                                                rules={[
                                                                    {
                                                                        validator: async (
                                                                            _,
                                                                            value,
                                                                        ) => {
                                                                            const fromValue =
                                                                                formReferrer.getFieldValue(
                                                                                    [
                                                                                        'groups',
                                                                                        idx,
                                                                                        'from',
                                                                                    ],
                                                                                );
                                                                            const allGroups =
                                                                                formReferrer.getFieldValue(
                                                                                    ['groups'],
                                                                                );

                                                                            const isLast =
                                                                                idx ===
                                                                                allGroups.length -
                                                                                    1;

                                                                            // Si es el último y está vacío, es válido
                                                                            if (
                                                                                isLast &&
                                                                                (value === null ||
                                                                                    value ===
                                                                                        undefined ||
                                                                                    value === '')
                                                                            ) {
                                                                                return Promise.resolve();
                                                                            }

                                                                            // Si 'from' no está definido, no podemos comparar
                                                                            if (fromValue == null)
                                                                                return Promise.resolve();

                                                                            if (value < fromValue) {
                                                                                return Promise.reject(
                                                                                    new Error(
                                                                                        t(
                                                                                            "El valor 'Hasta' debe ser igual o mayor al 'Desde'",
                                                                                        ),
                                                                                    ),
                                                                                );
                                                                            }

                                                                            return Promise.resolve();
                                                                        },
                                                                    },
                                                                ]}
                                                            >
                                                                <InputNumber
                                                                    addonBefore={t('to')}
                                                                    style={{ maxWidth: '140px' }}
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                        <div
                                                            className="col-1 p-0 m-0 row"
                                                            style={{
                                                                justifyContent: 'end',
                                                                alignItems: 'center',
                                                            }}
                                                        >
                                                            <Button
                                                                style={{
                                                                    display:
                                                                        idx > 0 ? 'block' : 'none',
                                                                    width: '30px',
                                                                    paddingBottom: 5,
                                                                }}
                                                                loading={loadingUpdate}
                                                                disabled={loadingUpdate}
                                                                type="text"
                                                                danger
                                                                icon={<DeleteOutlined />}
                                                                onClick={async () => {
                                                                    if (
                                                                        formReferrer.getFieldValue([
                                                                            'groups',
                                                                            name,
                                                                            'id',
                                                                        ]) == null
                                                                    ) {
                                                                        remove(name);
                                                                    } else {
                                                                        setLoadingUpdate(true);
                                                                        await restApiClient
                                                                            .deleteReferral(refId)
                                                                            .then(() => {
                                                                                remove(name);
                                                                            })
                                                                            .finally(() =>
                                                                                setLoadingUpdate(
                                                                                    false,
                                                                                ),
                                                                            );
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                    <Button
                                        type="dashed"
                                        block
                                        icon={<PlusOutlined />}
                                        onClick={() =>
                                            add({
                                                referenceReferralAmount: uuidv4(),
                                                percent: null,
                                                from: null,
                                                to: null,
                                                id: null,
                                            })
                                        }
                                    >
                                        {t('add-new-group')}
                                    </Button>
                                </div>
                            )}
                        </Form.List>
                    </Form>
                </div>
            </>
        );
    };
    const renderSectionReferred = () => {
        return (
            <>
                <div className="container-referral mb-4 ant-list-item p-0 not-line-down">
                    <div
                        style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
                    >
                        <TitleCustom
                            level={1}
                            class="title-section"
                            text={t('amount-agent-refered')}
                        />{' '}
                        <ButtonsCustom
                            content={t('save')}
                            type="primary"
                            disabled={loadingUpdate}
                            loading={loadingUpdate}
                            className="btn-primary"
                            onClick={() => handleSubmit('REFERRED')}
                        />
                    </div>
                    <ParagraphCustom text={t('amount-agent-refered-explain')} />

                    <Form.List name="groups">
                        {(fields, {}) => (
                            <>
                                {fields.map(({ key, name }, idx) => {
                                    const refId = form.getFieldValue([
                                        'groups',
                                        name,
                                        'referenceReferralAmount',
                                    ]);

                                    const radioValue = radioValueMapReferred[refId] ?? 2;

                                    return (
                                        <div
                                            style={{
                                                width: '100%',
                                                position: 'relative',
                                                paddingLeft: 20,
                                            }}
                                            key={key}
                                        >
                                            <Form.Item
                                                name={[name, 'referenceReferralAmount']}
                                                hidden
                                            >
                                                <Input />
                                            </Form.Item>
                                            <Radio.Group
                                                style={{ marginBottom: 5 }}
                                                onChange={(e) =>
                                                    setRadioValueMapReferred((prev) => ({
                                                        ...prev,
                                                        [refId]: e.target.value,
                                                    }))
                                                }
                                                value={radioValue}
                                            >
                                                <Space>
                                                    <Radio value={1}>{t('percent')}</Radio>
                                                    <Radio value={2}>{t('fixed')}</Radio>
                                                </Space>
                                            </Radio.Group>
                                            <div
                                                style={{ padding: 0, margin: 0, paddingTop: 5 }}
                                                className="col-12 row"
                                            >
                                                {radioValue === 1 && (
                                                    <Form.Item
                                                        className="p-0 m-0 col-12"
                                                        style={{
                                                            marginTop: 8,
                                                            padding: 0,
                                                            height: 'fit-content',
                                                        }}
                                                        name={[name, 'percent']}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Introduce un valor',
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            suffix="%"
                                                            max={100}
                                                            onChange={(e) =>
                                                                setRadioValuePercentajeReferred(
                                                                    (prev) => ({
                                                                        ...prev,
                                                                        [refId]: e.target.value,
                                                                    }),
                                                                )
                                                            }
                                                            value={
                                                                radioValuePercentajeReferred[refId]
                                                            }
                                                        />
                                                    </Form.Item>
                                                )}
                                                {radioValue === 2 && (
                                                    <>
                                                        <div
                                                            className="col-3 row"
                                                            style={{
                                                                gap: 12,
                                                                flexWrap: 'wrap',
                                                                padding: 0,
                                                                margin: 0,
                                                            }}
                                                        >
                                                            <Form.Item
                                                                className="p-0 m-0"
                                                                key={`${refId}_${currencyList[0]}`}
                                                                name={[name, currencyList[0]]}
                                                                help={false}
                                                                style={{ height: 'fit-content' }}
                                                                rules={[
                                                                    { required: radioValue == 2 },
                                                                ]}
                                                            >
                                                                <InputNumber
                                                                    style={{ maxWidth: '140px' }}
                                                                    disabled={
                                                                        loadingTransformCurrencies
                                                                    }
                                                                    addonBefore={currencyList[0]}
                                                                    decimalSeparator=","
                                                                />
                                                            </Form.Item>
                                                            <Button
                                                                loading={loadingTransformCurrencies}
                                                                disabled={
                                                                    loadingTransformCurrencies
                                                                }
                                                                type="primary"
                                                                onClick={() =>
                                                                    handleConvert(
                                                                        name,
                                                                        currencyList,
                                                                        'REFERRED',
                                                                    )
                                                                }
                                                            >
                                                                {t('convert')}
                                                            </Button>
                                                        </div>
                                                        <div
                                                            className="col-9"
                                                            style={{
                                                                display: 'flex',
                                                                gap: 12,
                                                                flexWrap: 'wrap',
                                                                padding: 0,
                                                            }}
                                                        >
                                                            {currencyList.map((cur, index) => (
                                                                <>
                                                                    {index > 0 && (
                                                                        <Form.Item
                                                                            className="p-0 m-0"
                                                                            key={`${refId}_${cur}`}
                                                                            name={[name, cur]}
                                                                            help={false}
                                                                            style={{
                                                                                height: 'fit-content',
                                                                            }}
                                                                            rules={[
                                                                                {
                                                                                    required:
                                                                                        radioValue ==
                                                                                        2,
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <InputNumber
                                                                                style={{
                                                                                    maxWidth:
                                                                                        '140px',
                                                                                }}
                                                                                disabled={
                                                                                    loadingTransformCurrencies
                                                                                }
                                                                                addonBefore={cur}
                                                                                decimalSeparator=","
                                                                            />
                                                                        </Form.Item>
                                                                    )}
                                                                </>
                                                            ))}
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </>
                        )}
                    </Form.List>
                </div>
            </>
        );
    };
    return (
        <div style={{ marginBottom: 90, padding: 0 }} className="col-12">
            <TitleCustom level={3} class="title-group-section " text={t('title')} />
            <ParagraphCustom class="p-0" text={t('subtitle')} />
            <Alert
                message={
                    <>
                        <TitleCustom
                            level={4}
                            style={{ marginBottom: 0 }}
                            class="title-group-section"
                            text={t('modalityReferral')}
                        />

                        <p style={{ marginBottom: 0 }}>
                            <Trans
                                i18nKey={
                                    referralsUniqueOrPerNight
                                        ? 'referrals:unique'
                                        : 'referrals:perNight'
                                }
                                components={{ strong: <strong /> }}
                            />
                        </p>
                        <p style={{ color: 'gray', fontSize: '12px' }}>
                            {t('infor-edit-modality-referral')}
                        </p>
                    </>
                }
            />
            <Skeleton active loading={loading} className="mt-4">
                <Form
                    className="d-flex flex-column mt-4"
                    form={form}
                    layout="vertical"
                    id="edit-referrals"
                >
                    {renderSectionReferred()}
                </Form>

                {renderSectionReferrer()}
            </Skeleton>
        </div>
    );
}
